import { defineMessages } from 'react-intl';

export default defineMessages({
  trigger: {
    id: 'appSidebar.accountMenu.trigger',
    defaultMessage: 'Account menu for {name}',
  },
  triggerNoName: {
    id: 'appSidebar.accountMenu.triggerNoName',
    defaultMessage: 'Account menu',
  },
  profile: {
    id: 'appSidebar.accountMenu.profile',
    defaultMessage: 'My profile',
  },
  organization: {
    id: 'appSidebar.accountMenu.organization',
    defaultMessage: 'Your organization',
  },
  logout: {
    id: 'appSidebar.accountMenu.logout',
    defaultMessage: 'Logout',
  },
  // Role labels: the header-card badge, and the trigger's secondary line for
  // non-admins (the subscription endpoint, which gives admins the plan name,
  // is admin-only).
  roleAdmin: {
    id: 'appSidebar.accountMenu.roleAdmin',
    defaultMessage: 'Admin',
  },
  roleManager: {
    id: 'appSidebar.accountMenu.roleManager',
    defaultMessage: 'Manager',
  },
  roleCreator: {
    id: 'appSidebar.accountMenu.roleCreator',
    defaultMessage: 'Creator',
  },
  roleUser: {
    id: 'appSidebar.accountMenu.roleUser',
    defaultMessage: 'User',
  },
});
